export const BG_WHITE_SHOW = 'BG_WHITE_SHOW';
export const BG_WHITE_REMOVE = 'BG_WHITE_REMOVE';
